<template>
  <div class="mx-sm-1 mt-0">
    <div class="page-header">
      <h1 class="page-title fw-bold">{{ $t('marketType.title') }}</h1>
    </div>

    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h3 class="card-title fw-bold mb-0">Types de marché</h3>

        <div class="card-options d-flex gap-2">
          <button
              v-if="canCreate"
              class="btn btn-outline-success btn-sm"
              @click="$emit('operation', { type: Operations.CREATE })"
          >
            <i class="fe fe-plus-circle me-1"></i> Ajouter
          </button>
        </div>
      </div>

      <div class="card-body">
        <TableWithFilters
            :columns="columns"
            :filterableFields="[]"
            :items="items"
            @row-click="onRowClick"
        >
          <template #cell-code="{ item }">
            <strong>{{ item.code }}</strong>
          </template>

          <template #cell-label="{ item }">
            {{ item.label }}
          </template>

          <template #cell-description="{ item }">
            {{ item.description }}
          </template>
        </TableWithFilters>
      </div>
    </div>

  </div>
</template>

<script>
  import TableWithFilters from "@/components/TableWithFilters.vue";
  import {Operations, Roles} from "../../../../helpers/roles";

  export default {
    name: "MarketTypeTable",
    components: { TableWithFilters },
    props: {
      items: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        columns: [
          { key: "code", label: "Code" },
          { key: "label", label: "Libellé" },
          { key: "description", label: "Description" }
        ]
      };
    },
    computed: {
      Operations() {
        return Operations;
      },
      canCreate() {
        return this.$can(Roles.MARKET_TYPE_CREATE);
      }
    },
    methods: {
      onRowClick(item) {
        this.$emit("operation", {
          type: Operations.VIEW,
          payload: item.code
        });
      }
    }
  };
</script>
